@if(component){

<text-box class="wrap block"
          [data]="component"
          [textAlign]="'center'"></text-box>

<div class="wrap pos-relative"
     [sizeClass]="'XL: m-t-10, SM: m-t-8 swiper-show-outside-wrap'">

    <!-- slider -->
    <carousel class="default-swiper swiper-slide-per-view block"
              [sizeClass]="'XL: m-r-17 m-l-17'"
              [class.swiper-center-content]="!canMove"
              [slidesPerView]="'auto'"
              [navigation]="{
                    addIcons:false,
                    nextEl: '.quick-links-next-' + uid,
                    prevEl: '.quick-links-prev-' + uid,
                    }"
              [scrollbar]="{ draggable: true }"
              [freeMode]="true"
              [style.--pc-slides-ceil]="pcSlidesCeil"
              [style.--pc-slides]="pcSlides"
              [style.--pc-gutter]="pcGutter"
              [style.--carousel-slides-per-view-round]="pcSlidesCeil"
              [style.--carousel-slides-per-view]="pcSlides"
              [style.--carousel-space-between]="pcGutter"
              imageViewRoot>
        @for(slide of component.links; track slide){
        <ng-template carouselSlide>
            <href [link]="slide.link">
                <df-image-wrapper>
                    <img class="w-12"
                         [ratio]="1"
                         [dfImage]="slide.image">
                </df-image-wrapper>
            </href>
            <div class="flex flex-middle flex-justify-center  m-t-2">
                <href [link]="slide.link">
                    <span class="p1"
                          *iCms="'title' of slide; content: 'basicHtml'; tag: slide.titleTag || 'span'"></span>
                </href>
            </div>
        </ng-template>
        }
    </carousel>
    <div class="pos-absolute top-50 default-arrows left-0 right-0 m-r-12 m-l-12"
         [class.ng-hide]="client.sizeId < 2 || !canMove">
        <button class="swiper-button-prev inline-flex flex-middle"
                [class]="'quick-links-prev-' + uid"
                role="button"
                aria-label="Previous slide"></button>
        <button class="swiper-button-next inline-flex flex-middle"
                [class]="'quick-links-next-' + uid"
                role="button"
                aria-label="Next slide"></button>
    </div>

</div>

}